// removed by extract-text-webpack-plugin
module.exports = {"link":"_29Txq","icon":"_3ciGL"};